import { useContext, useState, useEffect } from "react";
import { AuthContext } from "../../utils/AuthContext";
import Header from "../../../components/Header";
import axios from "axios";

function Profile() {
  const { user, dispatch } = useContext(AuthContext);

  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: ""
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    if (user) {
      setForm({
        name: user.name || "",
        email: user.email || "",
        phone: user.phone || ""
      });
    }
  }, [user]);

  const handleChange = (e) => {
    setForm((prev) => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);
      setSuccess(false);

      const res = await axios.put(
        `https://api.komorotel.com/api/users/${user._id}`,
        form,
        { withCredentials: true }
      );

      // 🔥 update context
      dispatch({
        type: "LOGIN_SUCCESS",
        payload: res.data
      });

      setSuccess(true);

    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  if (!user) {
    return <div className="pt-32 text-center">Non connecté</div>;
  }

  return (
    <>
      <Header />

      <div className="min-h-screen bg-gray-50 pt-28 px-4">
        <div className="max-w-3xl mx-auto">

          {/* CARD */}
          <div className="bg-white rounded-2xl shadow-sm p-8">

            {/* TITLE */}
            <h1 className="text-2xl font-semibold text-gray-900 mb-6">
              Mon profil
            </h1>

            {/* AVATAR */}
            <div className="flex items-center gap-4 mb-8">
              <div className="w-16 h-16 rounded-full bg-[#3A9D23] text-white flex items-center justify-center text-xl font-semibold">
                {form.name?.[0] || "U"}
              </div>

              <div>
                <p className="font-medium text-gray-900">
                  {form.name}
                </p>
                <p className="text-sm text-gray-500">
                  {form.email}
                </p>
              </div>
            </div>

            {/* FORM */}
            <form onSubmit={handleSubmit} className="space-y-6">

              {/* NAME */}
              <div>
                <label className="text-sm font-medium text-gray-700">
                  Nom complet
                </label>
                <input
                  type="text"
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                  className="
                    mt-1 w-full
                    border border-gray-300 rounded-xl px-4 py-3
                    focus:outline-none focus:ring-2 focus:ring-[#3A9D23]
                  "
                />
              </div>

              {/* EMAIL */}
              <div>
                <label className="text-sm font-medium text-gray-700">
                  Email
                </label>
                <input
                  type="email"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  className="
                    mt-1 w-full
                    border border-gray-300 rounded-xl px-4 py-3
                    focus:outline-none focus:ring-2 focus:ring-[#3A9D23]
                  "
                />
              </div>

              {/* PHONE */}
              <div>
                <label className="text-sm font-medium text-gray-700">
                  Téléphone
                </label>
                <input
                  type="text"
                  name="phone"
                  value={form.phone}
                  onChange={handleChange}
                  placeholder="+269..."
                  className="
                    mt-1 w-full
                    border border-gray-300 rounded-xl px-4 py-3
                    focus:outline-none focus:ring-2 focus:ring-[#3A9D23]
                  "
                />
              </div>

              {/* SUCCESS */}
              {success && (
                <div className="text-green-600 text-sm">
                  ✔️ Profil mis à jour
                </div>
              )}

              {/* BUTTON */}
              <button
                type="submit"
                disabled={loading}
                className="
                  w-full
                  bg-[#3A9D23] text-white
                  py-3 rounded-xl font-medium
                  hover:bg-[#33891E]
                  transition
                "
              >
                {loading ? "Enregistrement..." : "Enregistrer"}
              </button>

            </form>

          </div>

        </div>
      </div>
    </>
  );
}

export default Profile;